<template>
  <BaseDialogForm
    :title="`${tripPlanningModule.planningTemplate} Details`"
    v-model="showTemplateDetailsDialog"
    maxWidth="55%"
  >
    <template #content>
      <v-row class="ma-0">
        <v-col cols="12" class="d-flex">
          <v-icon class="pr-4" color="pickedup">mdi-clipboard-list-outline</v-icon>
          <div>
            <h4 class="font-weight-light">
              {{ tripPlanningModule.template }} Name
            </h4>
            <span class="font-weight-bold">{{ templateDetails.name }}</span>
          </div>
        </v-col>
        <v-col cols="12" class="pa-0 mt-4">
          <v-card elevation="0" outlined class="pa-4 rounded-lg">
            <v-row no-gutters>
              <v-col cols="6">
                <v-row>
                  <v-col cols="12" class="d-flex">
                    <v-icon class="pr-4" color="trip_active">mdi-cog</v-icon>
                    <div>
                      <h4 class="font-weight-light">
                        {{ configurationModule.configuration }}
                      </h4>
                      <span
                        class="font-weight-bold text-capitalize"
                        v-if="templateDetails.configuration"
                      >
                        {{ templateDetails.configuration.replace(/_/g, " ") }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="d-flex">
                    <v-icon class="pr-4" color="trip_active">mdi-truck</v-icon>
                    <div>
                      <h4 class="font-weight-light">Fill Ratio</h4>
                      <span class="font-weight-bold">
                        {{ templateDetails.fill_ratio }}</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="6">
                <div
                  v-for="(value, key, index) in templateDetails"
                  :key="index"
                >
                  <v-row
                    v-if="
                      [
                        'id',
                        'branch',
                        'name',
                        'configuration',
                        'fill_ratio',
                      ].indexOf(key) == -1
                    "
                    class="py-2"
                    no-gutters
                  >
                    <v-col cols="6">
                      <span class="text-capitalize"
                        >{{ key.replace(/_/g, " ") }}
                      </span>
                    </v-col>
                    <v-col cols="6" class="text-center">
                      <v-icon color="success" v-if="value"
                        >mdi-check-decagram</v-icon
                      >
                      <v-icon color="error" v-else>mdi-close-thick</v-icon>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { bus } from "@/main";
import {
  tripPlanningModule,
  tripModule,
  configurationModule,
} from "@/utils/moduleMapping";

export default {
  components: { BaseDialogForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: [Number, null],
    },
  },
  data() {
    return {
      tripPlanningModule,
      tripModule,
      configurationModule,
      templateDetails: {},
    };
  },
  watch: {
    value(val) {
      if (val) {
        if (this.templateId) {
          this.getTripPlanningTemplateObject(this.templateId);
        }
      }
    },
  },
  computed: {
    showTemplateDetailsDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getTripPlanningTemplateObject(id) {
      bus.$emit("showLoader", true);
      this.$api.tripPlanningTemplate
        .getTripPlanningTemplateObject(id)
        .then((res) => {
          this.templateDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
